<template>
  <div class="w-full">
    <div class="flex flex-row w-full border-grey-light">
      <gd-button
        v-for="side in sideKeys"
        :key="side"
        :dark="!isSelected(side)"
        :primary="isSelected(side)"
        size="expand"
        :group-position="getGroupPosition(side)"
        @click="selectSide(side);"
      >
        <component
          :is="sideContent(side)"
          v-if="typeof sideContent(side) !== 'string'"
          class=" h-3 w-4 fill-current"
        ></component>
        <span v-else>{{ sideContent(side) }}</span>
      </gd-button>
    </div>
  </div>
</template>
<script>
import GdButton from './Button';

export default {
  name: 'SidesPanel',
  components: { GdButton },
  props: ['sides', 'value', 'multi', 'options','cursorAllowed'],
  computed: {
    sideKeys() {
      return Object.keys(this.sides);
    }
  },
  methods: {
    getGroupPosition(side) {
      if (side === this.sideKeys[0]) return 'left';
      if (side === this.sideKeys[this.sideKeys.length - 1]) return 'right';
      return 'middle';
    },
    sideContent(side) {
      return this.sides[side];
    },
    selectSide(side) {
      let value = side;
      if (this.value === side) {
        value = null;
      }
      this.$emit('input', value);
      this.$emit('change', value);
      this.$forceUpdate();
    },
    isSelected(side) {
      if(this.options) {
        return this.options[side];
      }
      return this.value === side;
    }
  }
};
</script>
